import { Map } from 'mapbox-gl';
import { IMapViewModelPlugin } from './IMapViewModelPlugin.ts';
import { MapViewModel } from './MapViewModel.ts';
import { GPSPositionPlugin } from '../location/GPSPositionPlugin.ts';

export class MapViewModelCompositePlugin implements IMapViewModelPlugin {
    static inject = () => [GPSPositionPlugin];
    constructor(...plugins: IMapViewModelPlugin[]){
        this.plugins = plugins;
    }

    private plugins: IMapViewModelPlugin[];

    init = (mapViewModel: MapViewModel, map: Map) => {
        for (const plugin of this.plugins){
            plugin.init(mapViewModel, map);
        }
    };

}
